import { Outlet } from 'react-router-dom';

import { values } from 'lodash-es';

import { MainLayoutBase } from '@/layout/mainLayout/MainLayoutBase';
import { HeaderBase } from '@/layout/mainLayout/header';

import type { LookoRouteObject } from '../LookoRouteObject';
import { paymentMap } from './paymentMap';

const paymentRoutes: LookoRouteObject[] = [
  {
    path: paymentMap['application'].path,
    async lazy() {
      const { default: Page } = await import('@/app/payment/PlanApplicationPage');
      return {
        Component: Page,
      };
    },
    handle: {
      hideSidebar: true,
    },
  },
  {
    path: paymentMap['settlement'].path,
    async lazy() {
      const { default: Page } = await import('@/app/payment/ImmediatelyPaymentPage');
      return {
        element: <Page isRetry={false} />,
      };
    },
    handle: {
      hideSidebar: true,
    },
  },
  {
    path: paymentMap['retry'].path,
    async lazy() {
      const { default: Page } = await import('@/app/payment/ImmediatelyPaymentPage');
      return {
        element: <Page isRetry={true} />,
      };
    },
    handle: {
      hideSidebar: true,
    },
  },
];

export const 결제_페이지_루트: LookoRouteObject = {
  path: '/',
  element: (
    <MainLayoutBase appBar={<HeaderBase />}>
      <Outlet />
    </MainLayoutBase>
  ),
  children: values(paymentRoutes),
};

export default 결제_페이지_루트;
